module.exports = __webpack_public_path__ + "img/36558-077.7539dc12.jpg";